module.exports = __webpack_public_path__ + "img/chat-clear.1bb14221.svg";